// extracted by mini-css-extract-plugin
export default {"homeLink":"page_homeLink__awfZx","nonBorder":"page_nonBorder__Ns7go","pageWrapper":"page_pageWrapper__PSJkh"};